'use strict';


app.factory('Helper', ['$rootScope', 'localStorageService',
    function ($rootScope, localStorageService) {
        var service = {};


        /**
         * validate email
         *
         * @param  String   email
         * @return Boolean
         */
        service.validateEmail = function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }


        /**
         * update local storage with global variable
         */
        service.updateLocalStorageWithGlobalVariable = function () {
            localStorageService.set('globals', $rootScope.globals);
        }


        /**
         * round number
         *
         * @param Number  number
         * @param Number  decimals
         * @return Number
         */
        service.roundNumber = function (number, decimals) {
            // decimals = parseInt(decimals,10);
            // var dec = Math.pow(10,decimals);
            // number=""+Math.round(parseFloat(number)*dec); // notice the ceil to round up

            // return parseFloat(number.slice(0,-1*decimals) + "." + number.slice(-1*decimals));

            var d = parseInt(decimals, 10),
                dx = Math.pow(10, d),
                n = parseFloat(number),
                f = Math.round(Math.round(n * dx * 10) / 10) / dx;
            return Number(f.toFixed(d));
        }

        /**
         * Format Currency
         * @param Number amount 
         * @param string decimalCount 
         * @param string decimal 
         * @param string thousands 
         */
        service.formatCurrency = function (amount, decimalCount, decimal, thousands) {
            // Card 806: Multi-Currency / Multi-Gateway Feature
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
                const negativeSign = amount < 0 ? "-" : "";
                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;
                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            } catch (e) {
                console.log(e)
            }
        }

        /**
         * get property if it exists
         *
         * @param  Object obj
         * @param  String key
         * @return Mixed
         */
        service.getProperty = function (obj, key) {
            return key.split(".").reduce(function (o, x) {
                return (typeof o == "undefined" || o === null) ? o : o[x];
            }, obj);
        }

        /**
         * Get Facebook meta data
         */
        service.getFacebookMetaData = function (event) {
            var facebookMeta = new Object();
            facebookMeta.site_name = 'WAAVE';
            if (typeof event === "undefined" || event == null) {
                facebookMeta.title = 'Here is your first free drink!';
                facebookMeta.description = 'Use code to get free credits toward drinks or food on WAAVE. Download the app http://www.getwaave.com';
                facebookMeta.image = 'images/invite_to_waave_image.jpg';
            } else {
                facebookMeta.title = (typeof event.name !== "undefined") ? event.name : '';
                facebookMeta.description = (typeof event.date !== "undefined") ? event.date + ' - Get your tickets with WAAVE' : 'Get your tickets with WAAVE';
                facebookMeta.image = (typeof event.image.original !== "undefined") ? event.image.original : '';
            }
            return facebookMeta;
        }

        /**
         * Check mobile operating system
         */
        service.getMobileOperatingSystem = function () {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return WINDOWS_PHONE_TYPE;
            }

            // Android detection
            if (/android/i.test(userAgent)) {
                return ANDROID_TYPE;
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return IOS_TYPE;
            }

            return UNKNOWN_TYPE;
        }

        /**
         * Get redirect url if the user clicks View button on banner
         * @returns {string}
         */
        service.getRedirectUrl = function () {
            var deviceType = service.getMobileOperatingSystem();

            if (deviceType == ANDROID_TYPE) {
                return 'market://details?id=com.bmad.activity';
            } else if (deviceType == IOS_TYPE) {
                return 'itms://itunes.apple.com/us/app/apple-store/id433527858?mt=8';
            } else {
                return '';
            }
        }

        /**
         * Get WAAVE URL
         * @returns {string}
         */
        service.getWaaveUrl = function () {
            var user = service.getCookie('SendingUser');
            if (user != '') {
                return  'waave://user/' + user;
            }
            return 'waave://';
        }

        /**
         * Get coookie by name
         * @param name
         * @returns {string}
         */
        service.getCookie = function (name) {
            var name = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        /**
         * Set cookie
         * @param cookieName
         * @param expiration
         */
        service.setCookie = function (cookieName, expiration) {
            var exdays = expiration;
            var cname = cookieName;
            var cvalue = "true";
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + "; " + expires;
        }

        /**
         * Check app device to show customer banner
         */
        service.checkShowCustomerBanner = function () {
            var deviceType = service.getMobileOperatingSystem();
            var isSafari = navigator.userAgent.indexOf("Safari") > -1;

            if ((!isSafari && deviceType == IOS_TYPE) || deviceType == ANDROID_TYPE) {
                return true;
            }

            return false;
        }

        return service;
    }]);